import React, { useContext } from 'react';

import { sourceIconAccountsObjectAndPSE } from '../../store/catalogs/banks';
import Context from '../../store/context';
import Button from '../Buttons/Button/Button';
import DetailBank from './DetailBank/DetailBank';

import classes from './CardBankPayout.module.scss';

const CardBankPayout = ({
  className,
  nameId,
  bankId,
  subtypeLabel,
  bankLast4Digits,
  isButton = true,
  name,
  identification,
  methodForPay
}) => {
  const {
    modal: { showModal }
  } = useContext(Context);

  const showDetails = () => {
    showModal(
      <DetailBank
        methodForPay={methodForPay}
        bank={sourceIconAccountsObjectAndPSE[bankId]}
        subtypeLabel={subtypeLabel}
        bankNumber={`****${bankLast4Digits}`}
        name={name}
        identification={identification}
      />
    );
  };

  const contentClass = [classes['card-bank']];
  className && contentClass.push(className);


  
  return (
    <div name={nameId} className={contentClass.join(' ')}>
      <div className={classes['info-bank']}>
        <div className={classes.icon}>{sourceIconAccountsObjectAndPSE[bankId]}</div>
        <div className={classes['field-account']}>
          <span className='medium-16'>{methodForPay === 'PSEPay' ? `${name}` : methodForPay === 'cybersource' ? `${name}` : `${subtypeLabel}`}</span>
          <span className='medium-16'>{methodForPay === 'PSEPay' ? `${identification}` : methodForPay === 'cybersource' ? `${identification}` : `****${bankLast4Digits}`}</span>
        </div>
      </div>
      {isButton && (
        <div>
          <Button onClick={showDetails} custom='quaternary' size='sm'>
            Ver detalles
          </Button>
        </div>
      )}
    </div>
  );
};

export default CardBankPayout;
